import { PodiumRank, PodiumSize } from './interfaces';

export const PODIUM_DISPLAY_ORDER: PodiumRank[] = [2, 1, 3];

export const PODIUM_PANEL_PADDING: Record<
  PodiumSize,
  {
    pt: number;
    pb: number;
  }
> = {
  default: {
    pt: 2.5,
    pb: 1,
  },
  large: {
    pt: 3.5,
    pb: 2,
  },
};

export const PODIUM_PANEL_MIN_HEIGHT: Record<
  PodiumSize,
  Record<PodiumRank, number>
> = {
  default: {
    1: 132,
    2: 108,
    3: 108,
  },
  large: {
    1: 198,
    2: 162,
    3: 162,
  },
};

export const PODIUM_ENTRY_SIZES: Record<
  PodiumSize,
  {
    avatar: number;
    nameFontSize: string;
    scoreFontSize: Record<PodiumRank, string>;
    trophyFontSize: number;
    rankBadge: {
      size: number;
      fontSize: string;
      top: number;
    };
  }
> = {
  default: {
    avatar: 80,
    nameFontSize: '0.85rem',
    scoreFontSize: {
      1: '1.35rem',
      2: '1.1rem',
      3: '1.1rem',
    },
    trophyFontSize: 18,
    rankBadge: {
      size: 24,
      fontSize: '0.75rem',
      top: -12,
    },
  },
  large: {
    avatar: 120,
    nameFontSize: '1.28rem',
    scoreFontSize: {
      1: '2rem',
      2: '1.65rem',
      3: '1.65rem',
    },
    trophyFontSize: 27,
    rankBadge: {
      size: 36,
      fontSize: '1.125rem',
      top: -18,
    },
  },
};

export const PODIUM_STYLES: Record<
  PodiumRank,
  {
    badgeColor: string;
    scoreColor: string;
    border?: string;
  }
> = {
  1: {
    badgeColor: '#D4AF37',
    scoreColor: '#D4AF37',
    border: '2px solid rgba(212, 175, 55, 0.9)',
  },
  2: {
    badgeColor: '#BFC5CE',
    scoreColor: '#FFFFFF',
  },
  3: {
    badgeColor: '#CD7F32',
    scoreColor: '#CD7F32',
  },
};
